module.exports = __webpack_public_path__ + "img/alberta-icon.7c192f0b.svg";